/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import {
  dispatch,
  IAppState,
  IMediaSearchStateModel,
  IStateModel,
  IUserModel,
  IUserSettingsModel,
  MediaStore,
  RouteHelper,
  useConfigurationSelector,
  useIsLoggedIn,
  UserStore,
} from "@xala/common";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { AuthScreen } from "../AuthScreen";

import { ProfileDetails } from "./ProfileComponents/ProfileDetails";

export const ProfileDetailsScreen = () => {
  const isLoggedIn = useIsLoggedIn();
  const configuration = useConfigurationSelector();

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(UserStore.Actions.getUserConsents());
      dispatch(UserStore.Actions.getProfile());
      dispatch(UserStore.Actions.getUserSettings());
      dispatch(
        MediaStore.Actions.searchMedia({
          PageNumber: 1,
          PageSize: 100,
          IncludeImages: true,
          Types: ["CHANNEL"],
        })
      );
    } else {
      RouteHelper.goToLogin();
    }
  }, [isLoggedIn]);

  useEffect(() => {
    const script = document.getElementById(
      "script_of_FSWebChat"
    ) as HTMLScriptElement | null;

    if (!script) {
      (function (d, s) {
        const fs: any = ((window as any).FSWebChat = function () {});
        fs._s = d.createElement(s);
        fs._h = d.getElementsByTagName(s)[0];
        fs._domain = "2cb42dff-609e-47c4-9223-55ebd44ec118";
        fs._hashkey = "c2e5a0d602a8486257ab6f799f308e4ca3f8e9ec";
        fs._subfolder = "/profile";
        fs._server = "https://es-i1-cloud01.gocontact.com:443/poll";
        fs._service = "/new-webchat-service";
        fs._timestamp = +new Date();
        fs._s.setAttribute("charset", "utf-8");
        fs._s.src =
          fs._server +
          fs._service +
          "/startup/" +
          fs._domain +
          "/" +
          fs._hashkey;
        fs._s.type = "text/javascript";
        fs._s.async = true;
        fs._s.id = "script_of_FSWebChat";
        fs._h.parentNode.insertBefore(fs._s, fs._h);
      })(document, "script");
    }

    return () => {
      if (
        !location.pathname.includes("profile") &&
        !location.pathname.includes("contacte")
      ) {
        const script = document.getElementById(
          "script_of_FSWebChat"
        ) as HTMLScriptElement | null;
        const chatContainer = document.getElementById("fs_webchat_container");

        script && document.head.removeChild(script);
        chatContainer && document.body.removeChild(chatContainer);
      }
    };
  }, []);

  const userFavoriteContents = useSelector<
    IAppState,
    IUserSettingsModel | undefined
  >((state) => state.user.settings as IUserSettingsModel);

  const userPersonalData = useSelector<
    IAppState,
    IStateModel<IUserModel> | undefined
  >((state) => state.user.profile);

  const mediaChannels = useSelector<IAppState, IMediaSearchStateModel>(
    (state) => state.media.mediaSearch
  );

  const favChannels = userFavoriteContents?.Channels;

  const favChannelIds = new Set(favChannels?.map((f) => f.Id));

  const channels = mediaChannels.Entities.filter((m) =>
    favChannelIds.has(m.Id)
  );

  return (
    <AuthScreen configuration={configuration} visibility={7}>
      <ProfileDetails
        fullName={userPersonalData?.Data?.FullName}
        email={userPersonalData?.Data?.Email}
        dateOfBirth={userPersonalData?.Data?.DateOfBirth}
        towns={userFavoriteContents?.Towns}
        categories={userFavoriteContents?.Categories}
        channels={channels}
        isLoading={mediaChannels.IsLoading && userPersonalData?.IsProcessing}
      />
    </AuthScreen>
  );
};
